import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";

const PrViewSinglePage = () => {
   useAuthRedirect();
    const {priorNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [indentView, setIndentView] = useState({});
  const [indentView1, setIndentView1] = useState({});
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);

  const canView  = hasPermission("Prior Purchase Approval", "view");

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_detailsHeader?priorNo=${priorNo}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                prHeader_number: items[0].prHeader_number || "N/A",
                branchmaster_name: items[0].branchmaster_name || "N/A",
                prHeader_hod: items[0].prHeader_hod || "N/A",
                prHeader_remarks: items[0].prHeader_remarks || "N/A",
                prHeader_date: items[0].prHeader_date || "N/A",
                prHeader_headMaterial: items[0].prHeader_headMaterial || "N/A",
                
                
            };

            setIndentView(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [priorNo]); 

  useEffect(() => {
    const fetchIndentDetails1 = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_detailsHeader1?priorNo=${priorNo}&branch=${branch}`);
            const items = response.data.headerDetails1;
            const storeReqHeader1 = {
                prDetail_supplierCode: items[0].PrDetail_supplierCode || "N/A",
                supplierMaster_name: items[0].supplierMaster_name || "N/A",
                itemCode : items[0].itemmaster_code || "N/A",
            };
            setIndentView1(storeReqHeader1);
            setData(response.data.headerDetails1);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails1();
  }, [priorNo, branch]); 



  useEffect(() => {
    if (indentView1.prDetail_supplierCode && data.length > 0) {
      const itemCodes = data.map(item => item.PrDetail_itemCode).join(",");
      console.log(itemCodes);
      
  
      axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_detailsBill?branch=${branch}&supplier=${indentView1.prDetail_supplierCode}&item=${itemCodes}`)
        .then((response) => {
          setData1(response.data.headerDetails2);
          console.log(response.data.headerDetails2);
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
        });
    }
  }, [branch, indentView1.prDetail_supplierCode, data]); // Dependency on `data`
  
   if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
                    <h2 className="add-txt">Prior Purchase Requisition - View</h2>
                    <Link to='/inventory/prview'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          
          
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>Prior Pr Req No :</label>
                <input type="text" name="indentNo" value={indentView.prHeader_number} readOnly/>
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
  type="text"
  name="endhrs"
  value={indentView.prHeader_date ? new Date(indentView.prHeader_date).toISOString().split("T")[0] : ""}
 readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="indentNo" value={indentView1.prDetail_supplierCode} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" value={indentView1.supplierMaster_name} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Branch :</label>
                <input type="text" name="indentNo" value={indentView.branchmaster_name} readOnly/>
              </div>
              <div className="form-group">
                <label>HOD :</label>
                <input type="text" value={indentView.prHeader_hod} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={indentView.prHeader_remarks} name="remarks" readOnly />
              </div>
              <div className="form-group">
                <label>Indenter</label>
                <input type="text" value={indentView.prHeader_headMaterial} name="remarks" readOnly />
              </div>
            </div>


            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Total</th>
                    <th>Disc Amt</th>
                    <th>Amount</th>
                    <th>Due Date</th>
                  </tr>
                </thead>
<tbody>
  {data.length > 0 ? (
    <>
      {data.map((item, index) => {
        const total = item.prDetail_price * item.prDetail_quantity;

        // Find matching discount for the item
        const matchingDiscount = data1.find(
          (discountItem) =>
            discountItem.supplierWIdetail_itemcode === item.PrDetail_itemCode
        );
        const discountPercentage = matchingDiscount
          ? matchingDiscount.supplierWIdetail_discountPercentage
          : 0;

        // Calculate discount amount
        const discountAmt = (discountPercentage / 100) * total;

        // Final after discount
        const finalAmt = total - discountAmt;

        return (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>
              <Link
                to={`/inventory/comparisionSupplierWithItemViewsingle/${item.PrDetail_itemCode}`}
              >
                {item.PrDetail_itemCode}
              </Link>
            </td>
            <td>{item.itemMaster_name}</td>
            <td>{item.itemMaster_uom}</td>
            <td>{item.prDetail_quantity}</td>
            <td>{item.prDetail_price}</td>
            <td>{total.toFixed(2)}</td> {/* Full Amount */}
            <td>{discountAmt.toFixed(2)}</td> {/* Discount */}
            <td>{finalAmt.toFixed(2)}</td> {/* Final Amount */}
            <td>
              {new Date(item.prDetail_duedate).toLocaleDateString("en-GB")}
            </td>
          </tr>
        );
      })}

      {/* Total Row */}
      <tr>
        <td
          colSpan="6"
          style={{ textAlign: "right", fontWeight: "bold", color: "red" }}
        >
          Totals:
        </td>
        <td style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>
          {/* Total Full Amount */}
          {data
            .reduce(
              (sum, item) => sum + item.prDetail_price * item.prDetail_quantity,
              0
            )
            .toFixed(2)}
        </td>
        <td style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>
          {/* Total Discount */}
          {data
            .reduce((sum, item) => {
              const total = item.prDetail_price * item.prDetail_quantity;
              const matchingDiscount = data1.find(
                (discountItem) =>
                  discountItem.supplierWIdetail_itemcode === item.PrDetail_itemCode
              );
              const discountPercentage = matchingDiscount
                ? matchingDiscount.supplierWIdetail_discountPercentage
                : 0;
              return sum + (discountPercentage / 100) * total;
            }, 0)
            .toFixed(2)}
        </td>
        <td style={{ textAlign: "center", fontWeight: "bold", color: "red" }}>
          {/* Final Grand Total */}
          {data
            .reduce((sum, item) => {
              const total = item.prDetail_price * item.prDetail_quantity;
              const matchingDiscount = data1.find(
                (discountItem) =>
                  discountItem.supplierWIdetail_itemcode === item.PrDetail_itemCode
              );
              const discountPercentage = matchingDiscount
                ? matchingDiscount.supplierWIdetail_discountPercentage
                : 0;
              const discountAmt = (discountPercentage / 100) * total;
              return sum + (total - discountAmt);
            }, 0)
            .toFixed(2)}
        </td>
        <td></td>
      </tr>
    </>
  ) : (
    <tr>
      <td colSpan="10">No items</td>
    </tr>
  )}
</tbody>



              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default PrViewSinglePage;
